
import { createApiClient } from 'Network/ApiClient';
  
  export const NetworkAxiosInstance = createApiClient('network/');


